/**
 * PATH: packages/email-hub/src/feature/lib/mailboxPresentation.ts
 * FILE_ID: EMAILHUB-FEATURE-LIB-MAILBOX-PRESENTATION-001
 * PURPOSE: Pure presentation helpers for connected-mailbox UI — sync-age
 *          formatting + provider label/badge mapping.
 * WHY: Both the ConnectedMailboxesPanel and the right-click menu-item
 *      builder need the SAME provider label ("Gmail"/"Microsoft"), so the
 *      mapping lives in one pure module instead of being duplicated.
 * FLOW:
 * ┌────────────┐ ┌─────────────────┐ ┌──────────────┐
 * │ raw value  │ → │ pure transform  │ → │ display str  │
 * └────────────┘ └─────────────────┘ └──────────────┘
 */

/** Pure I→O: seconds-since-last-sync → human label. */
export function formatSyncAge(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds)) return 'never'
  if (seconds < 60) return 'just now'
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86400)}d ago`
}

/** Pure I→O: provider key → operator-facing label. */
export function providerLabel(provider: string): string {
  if (provider === 'gmail') return 'Gmail'
  if (provider === 'outlook') return 'Microsoft'
  return provider
}

/** Pure I→O: provider key → Tailwind badge class. */
export function providerBadgeClass(provider: string): string {
  if (provider === 'gmail') {
    return 'bg-[#EA4335]/15 text-[#EA4335] dark:text-[#F28B82]'
  }
  return 'bg-[#0078D4]/15 text-[#0078D4] dark:text-[#6CB4EE]'
}
